export type S3UploadFailureKind =
  | "http"
  | "network"
  | "timeout"
  | "cancelled"
  | "missing-etag";

export class S3UploadError extends Error {
  readonly kind: S3UploadFailureKind;
  readonly httpStatus?: number;
  readonly s3Code?: string;
  readonly s3RequestId?: string;

  constructor(
    message: string,
    details: {
      kind: S3UploadFailureKind;
      httpStatus?: number;
      s3Code?: string;
      s3RequestId?: string;
    },
  ) {
    super(message);
    this.name = "S3UploadError";
    this.kind = details.kind;
    this.httpStatus = details.httpStatus;
    this.s3Code = details.s3Code;
    this.s3RequestId = details.s3RequestId;
  }
}
